module.exports = __webpack_public_path__ + "static/media/zeiss_yardim.d700026a.pdf";